import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import MagicVerify from "./pages/MagicVerify";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import WikiLanding from "./pages/WikiLanding";
import NotFound from "./pages/NotFound";
import "./App.css";

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            border: "3px solid #000",
                            borderRadius: 0,
                            boxShadow: "4px 4px 0 0 #000",
                            fontFamily: "'Space Mono', monospace",
                        },
                    }}
                />
                <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/auth/magic" element={<MagicVerify />} />
                    <Route path="/auth/forgot" element={<ForgotPassword />} />
                    <Route path="/auth/reset" element={<ResetPassword />} />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute requireAdmin>
                                <Admin />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/wiki"
                        element={
                            <ProtectedRoute>
                                <WikiLanding />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/wiki/:slug"
                        element={
                            <ProtectedRoute>
                                <WikiLanding />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}
